const isBase64 = (str) => {
  const len = str?.length
  const re = /^[A-Za-z0-9+/]+[=]{0,2}$/
  return len % 4 === 0 && re.test(str)
}

const parseSTL = (base64DataWithPrefix) => {
  const base64Data = base64DataWithPrefix?.replace('data:application/octet-stream;base64,', '')

  if (!isBase64(base64Data)) {
    console.error('Invalid base64 data')
    return []
  }

  const buffer = Uint8Array.from(atob(base64Data), (c) => c.charCodeAt(0)).buffer
  const dataView = new DataView(buffer)
  const vertexArray = []
  let index = 84 // Skip header

  const numTriangles = dataView.getUint32(80, true)

  for (let i = 0; i < numTriangles; i++) {
    index += 12 // skip normal vector

    for (let j = 0; j < 3; j++) {
      const x = dataView.getFloat32(index, true)
      index += 4
      const y = dataView.getFloat32(index, true)
      index += 4
      const z = dataView.getFloat32(index, true)
      index += 4

      vertexArray.push([x, y, z])
    }

    index += 2 // skip attribute byte count
  }

  return vertexArray
}

export default parseSTL
